import "./financeList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import FinanceTable from "../financetable/FinanceTable";

const FinanceList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <FinanceTable />
      </div>
    </div>
  );
};

export default FinanceList;
